/**
 * @Author: v_jppjpeng
 * @Date: 2023-02-01 16:43:47
 * @Explain: 菜单 - 子集
 */
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { Icon } from '../tdesign';

type PropsType = {
  leftIconProps?: any;
  selected?: boolean;
  icon?: string;
  titleKey: string;
  // 标题箭头
  isCollapse?: boolean;
  // 是否有下级
  isChildren?: boolean;
  className?: string;
  onClick?: () => void;
};
export default function MenuItem(props: PropsType) {
  const {
    leftIconProps,
    selected,
    icon,
    titleKey,
    isCollapse,
    isChildren,
    className,
    onClick,
  } = props;

  return (
    <div
      className={classNames('menu-item-button', {
        'is-selected': selected,
        'is-children-selected': selected && isChildren,
      })}
      title={intlGet(titleKey)}
      onClick={onClick}
    >
      {icon && (
        <div className="item-icon" {...leftIconProps}>
          <Icon.Font name={icon} />
        </div>
      )}

      <span className={classNames('item-text', className)}>
        {intlGet(titleKey)}
      </span>

      {isChildren ? (
        <div className={classNames('item-right', { active: isCollapse })}>
          <Icon.Font name="arrow-right" />
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
